<section class="content">
  <div class="container">
    <h3 class="text strat pt-3">Enter Vehicle Make Name</h3>
    <form (ngSubmit)="saveVehicleMake()" [formGroup]="addVehicleMakeForm">
      <div class="row pt-3">
        <div class="col-md-6">
          <label for="name">Name</label>
          <input
            formControlName="name"
            id="name"
            type="text"
            class="form-control"
            required
            placeholder="Enter vehicle make name*"
            >
            @if (
              addVehicleMakeForm.get('name')?.invalid &&
              addVehicleMakeForm.get('name')?.touched
              ) {
              <div
                >
                <small class="text-danger">Vehicle make name is required</small>
              </div>
            }
          </div>
          <div class="col-md-3 text-end p-4">
            <button
              type="submit"
              class="btn app-btn-primary"
              [disabled]="addVehicleMakeForm.invalid"
            >Submit</button>
            <div>{{responseMsg}}</div>
          </div>
        </div>
      </form>
    </div>
  </section>
